module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "name": "frmname",
      "id": "frmname",
      "method": "post",
      "action": _vm.submitUrl,
      "accept-charset": "utf-8"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.$v.$invalid === false ? _vm.save() : ''
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.successUrl),
      expression: "successUrl",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden",
      "name": "success-url",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.successUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.successUrl = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (!_vm.isPrefilled) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('float-label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key),
      expression: "key",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__input",
    attrs: {
      "type": "text",
      "placeholder": "Key",
      "name": "key"
    },
    domProps: {
      "value": (_vm.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('i', {
    staticClass: "form-group__icon"
  })])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('float-label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.manualusername),
      expression: "manualusername",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__input",
    attrs: {
      "type": "text",
      "placeholder": "Username",
      "name": "manualusername"
    },
    domProps: {
      "value": (_vm.manualusername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manualusername = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('i', {
    staticClass: "form-group__icon"
  })]), (_vm.$v.newpassword.$error) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("Password requirements")]) : _vm._e()], 1)]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.token),
      expression: "token",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden",
      "name": "token",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden",
      "name": "username",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "form-group",
    class: {
      'form-group--error': _vm.$v.newpassword.$error,
      'form-group--valid': _vm.$v.newpassword.$dirty && !_vm.$v.newpassword.$error
    }
  }, [_c('float-label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newpassword),
      expression: "newpassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__input",
    attrs: {
      "autocomplete": "false",
      "type": "password",
      "placeholder": "Password",
      "name": "newpassword"
    },
    domProps: {
      "value": (_vm.newpassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newpassword = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.newpassword.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('i', {
    staticClass: "form-group__icon"
  })]), (!_vm.$v.newpasswordrepeat.invalid) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("Min 8 characters, at least 1 num, 1 capital, 1 special")]) : _vm._e()], 1), _c('div', {
    staticClass: "form-group",
    class: {
      'form-group--error': _vm.$v.newpasswordrepeat.$error,
      'form-group--valid': _vm.$v.newpasswordrepeat.$dirty && !_vm.$v.newpasswordrepeat.$error
    }
  }, [_c('float-label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newpasswordrepeat),
      expression: "newpasswordrepeat",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__input",
    attrs: {
      "autocomplete": "false",
      "type": "password",
      "placeholder": "Password (repeat)",
      "name": "newpasswordrepeat",
      "debounce": "500"
    },
    domProps: {
      "value": (_vm.newpasswordrepeat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newpasswordrepeat = $event.target.value.trim()
      }, function($event) {
        return _vm.$v.newpasswordrepeat.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('i', {
    staticClass: "form-group__icon"
  })]), (!_vm.$v.newpasswordrepeat.sameAsPassword) ? _c('span', {
    staticClass: "form-group__message"
  }, [_vm._v("Passwords don't match")]) : _vm._e()], 1), _c('div', {
    staticClass: "btn-group btn-group--outside txt-center"
  }, [_c('el-button', {
    staticClass: "btn btn--shadow btn--primary btn--big",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6775c263","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/my-account-validate.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6775c263","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/my-account-validate.vue
// module chunks = 0